import { ABOUT } from "@/constants/testIds/site";

const ABOUT_IMG =
  "https://images.unsplash.com/photo-1632927063333-df848f5f916a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBnbGFzcyUyMGNsZWFuaW5nJTIwc3F1ZWVnZWV8ZW58MHx8fHwxNzgxMzc1MjE3fDA&ixlib=rb-4.1.0&q=85";

export default function About() {
  return (
    <section
      id="about"
      data-testid={ABOUT.section}
      className="relative py-24 md:py-32 px-6 md:px-10"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-5">
            <div className="text-xs font-bold tracking-[0.2em] uppercase text-emerald-700">
              About J7 Collective
            </div>
            <h2 className="mt-4 font-display text-4xl md:text-5xl lg:text-6xl font-light tracking-tight text-emerald-950">
              Twenty years of <span className="italic font-semibold">glass mastery</span>, distilled into one trusted service.
            </h2>
            <p className="mt-6 text-slate-600 text-lg leading-relaxed max-w-lg">
              J7 Collective Ltd is the on‑site arm of two decades working
              directly with Ritec — the original creators of ClearShield. Led
              by a master applicator with 20 years at Ritec and backed by a
              full team of trained applicators, we’ve protected tens of
              thousands of glass surfaces across the UK.
            </p>
            <p className="mt-4 text-slate-600 text-lg leading-relaxed max-w-lg">
              Our team brings the workshop to your doorstep. Same coating.
              Same precision. Done in hours, not days.
            </p>
          </div>

          <div className="lg:col-span-7 grid grid-cols-6 grid-rows-6 gap-4 h-[520px]">
            <div className="col-span-4 row-span-6 zoom-wrap rounded-3xl overflow-hidden relative">
              <img
                src={ABOUT_IMG}
                alt="Professional glass treatment"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-emerald-950/40 to-transparent" />
              <div className="absolute bottom-6 left-6 right-6 text-white">
                <div className="text-[10px] font-bold tracking-widest uppercase opacity-80">
                  Field operations
                </div>
                <div className="font-display text-xl font-semibold mt-1">
                  Precision applied on‑site
                </div>
              </div>
            </div>

            <div
              data-testid={ABOUT.yearsBadge}
              className="col-span-2 row-span-2 rounded-3xl bg-gradient-to-br from-emerald-600 to-emerald-800 p-5 flex flex-col justify-between text-white hover-lift"
            >
              <div className="text-[10px] font-bold tracking-widest uppercase opacity-80">
                Experience
              </div>
              <div>
                <div className="font-display text-5xl font-bold leading-none">20</div>
                <div className="text-sm font-medium opacity-90 mt-1">
                  Years with Ritec
                </div>
              </div>
            </div>

            <div
              data-testid={ABOUT.warrantyBadge}
              className="col-span-2 row-span-2 rounded-3xl bg-emerald-950 p-5 flex flex-col justify-between text-white hover-lift"
            >
              <div className="text-[10px] font-bold tracking-widest uppercase opacity-70">
                Guarantee
              </div>
              <div>
                <div className="font-display text-5xl font-bold leading-none">10</div>
                <div className="text-sm font-medium opacity-80 mt-1">
                  Year protection
                </div>
              </div>
            </div>

            <div
              data-testid={ABOUT.jobsBadge}
              className="col-span-2 row-span-2 rounded-3xl border border-slate-200 bg-white p-5 flex flex-col justify-between hover-lift"
            >
              <div className="text-[10px] font-bold tracking-widest uppercase text-emerald-700">
                The Team
              </div>
              <div>
                <div className="font-display text-3xl font-bold leading-none text-emerald-950">
                  Trained crew
                </div>
                <div className="text-sm text-slate-500 mt-1">
                  UK‑wide, on‑site
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
